import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import News from "../components/News/News";
import Searchbar from "../components/Searchbar/Searchbar";
import { fetchStaticData } from "../services/tweetService";
import { BASE_WEB_URL } from "../CONSTANTS";

export default function Privacy() {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [privacy, setPrivacy] = useState("");
  useEffect(() => {
    fetchStaticData("privacy").then((data) => setPrivacy(data));
  }, [dispatch]);

  return (
    <>
      <div className="notificationspage two-flex-col-container">
        <div className="col1 npc-1">
          {privacy && (
            <>
              <div className="notificationspage-header">
                <span className="notifications-text">{privacy.title}</span>
              </div>
              <p style={{ margin: "1rem" , color:"#fff" }}>{privacy.content}</p>
              {/* <div className="constitution-div">
                {privacy != "" && (
                  <embed src={BASE_WEB_URL + privacy.asset_file} />
                )}
              </div> */}
            </>
          )}
        </div>
        <div className="col2 follow-sugg-news-container">
          <div className="follow-sugg-news-wrap">
            <Searchbar
              input={searchQuery}
              setInput={(value) => setSearchQuery(value)}
            />
            <News />
            {/* <WhoToFollow /> */}
          </div>
        </div>
      </div>
    </>
  );
}
